import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isMobile } from 'globals/utils';
import { injectIntl, intlShape } from 'react-intl';
import * as keyboardEventHelpers from 'globals/keyboardEvents';

import { validateEmail, validatePhone } from 'globals/validation';
import InputExpanding from 'shared/components/InputExpanding';

import ChatFormEnumButton from '../../form/ChatFormEnumButton';
import styles from './styles';
import * as chatAppSelectors from '../../app/ChatApp/selectors';
import * as actions from './actions';
import ConversationInputStyles from '../ChatConversationInput/styles';
import messages from './messages';

export class ChatConversationVolumeControlInput extends Component {
  constructor(props) {
    super(props);
    this._input = {
      focus: () => {},
    };
    this.state = {
      address: '',
      channel: '',
    };
  }

  componentDidMount() {
    if (this._input && !isMobile()) {
      this._input.focus();
    }
  }

  getErrorPlaceholder = () => {
    const { intl } = this.props;
    const { error, channel } = this.state;
    if (!error) return '';
    if (channel === 'email') {
      return intl.formatMessage(messages.placeholder_error_email);
    }
    return intl.formatMessage(messages.placeholder_error_phone);
  };

  handleKeyPress = e => {
    const { error } = this.state;

    if (error) this.setState({ error: false });

    if (keyboardEventHelpers.isEnterKey(e)) {
      e.preventDefault();
      e.stopPropagation();
      if (!this.state.channel) return;

      this.handleAddressSubmit();
    }
  };

  handleSubmitReplyChannel = channel => {
    const { sessionId } = this.props;
    if (channel === 'wait') {
      this.props.handleChooseReplyChannelWait(sessionId);
      return;
    }
    this.setState({ channel });
    this.props.handleChooseReplyChannel(channel, sessionId);
  };

  handleAddressSubmit = () => {
    const { sessionId } = this.props;
    const { address, channel } = this.state;

    if (channel === 'email' && !validateEmail(address)) {
      this.setState({ error: true, address: '' });
      return;
    } else if (channel !== 'email' && !validatePhone(address)) {
      this.setState({ error: true, address: '' });
      return;
    }

    this.setState({ address: '' });

    if (isMobile()) this._input.blur();

    this.props.handleReplyChannelAddress(address, sessionId);
  };

  handleAddressChange = e => {
    this.setState({
      address: e.target.value,
    });
  };

  renderReplyChannelAddress = () => {
    const { intl } = this.props;
    const { error } = this.state;
    return (
      <div style={Object.assign({}, styles.wrapper, ConversationInputStyles[error ? 'hasError' : {}])}>
        <InputExpanding
          ref={c => (this._input = c)}
          placeholder={this.getErrorPlaceholder() || intl.formatMessage(messages.placeholder)}
          onKeyPress={this.handleKeyPress}
          value={this.state.address}
          onChange={this.handleAddressChange}
          tabIndex="0"
        />
        <div
          style={styles.enter}
          className="enterIcon kustomer-app-reply-input-enter-button"
          onClick={this.handleAddressSubmit}
          onKeyPress={this.handleKeyPress}
          tabIndex="0"
        >
          <div style={styles.enterIcon} />
        </div>
      </div>
    );
  };

  renderReplyChannel = () => {
    const { intl } = this.props;
    const { followUpChannels } = this.props;
    return (
      <div className="volumeControlButtonWrap kustomer-app-reply-input-option-prompt" style={styles.wrapperOptions}>
        {followUpChannels.map((channel, i) => {
          const displayName = channel === 'wait' ? intl.formatMessage(messages.wait_label) : channel;
          return (
            <ChatFormEnumButton
              key={`${channel}-${i}`}
              displayName={displayName}
              value={channel}
              onClick={this.handleSubmitReplyChannel}
            />
          );
        })}
      </div>
    );
  };

  render() {
    if (!this.state.channel) {
      return this.renderReplyChannel();
    }

    return this.renderReplyChannelAddress();
  }
}

export const mapStateToProps = state => {
  return {
    sessionId: chatAppSelectors.getActiveSessionId(state),
    followUpChannels: chatAppSelectors.selectVolumeControlFollowupChannelOptions(state),
    userId: '',
  };
};

export const mapDispatchToProps = (dispatch, props) => ({
  handleChooseReplyChannelWait(sessionId) {
    dispatch(actions.handleChooseWait(sessionId));
  },
  handleChooseReplyChannel(data, sessionId) {
    dispatch(actions.handleChooseReplyChannel(sessionId, data, props.intl));
  },
  handleReplyChannelAddress(data, sessionId) {
    dispatch(actions.handleSubmitReplyChannelAddress(sessionId, data, props.intl));
  },
  handleSubmit(data, sessionId) {
    dispatch(actions.handleFormSubmit(sessionId));
  },
});

ChatConversationVolumeControlInput.propTypes = {
  sessionId: React.PropTypes.string,
  followUpChannels: React.PropTypes.arrayOf(React.PropTypes.string).isRequired,
  handleChooseReplyChannelWait: React.PropTypes.func.isRequired,
  handleChooseReplyChannel: React.PropTypes.func.isRequired,
  handleReplyChannelAddress: React.PropTypes.func.isRequired,
  intl: intlShape.isRequired,
};

ChatConversationVolumeControlInput.defaultProps = {
  sessionId: null,
  followUpChannels: [],
};

export const connectedComponent = connect(mapStateToProps, mapDispatchToProps)(ChatConversationVolumeControlInput);

// only for testing
export const intlComponent = injectIntl(ChatConversationVolumeControlInput);

export default injectIntl(connectedComponent);
